import { __ } from "@wordpress/i18n";
import Constants from "../constants";
import BSHelper from "../BSHelper";

const JobsList = ({ jobs, phrases }) => {
	// console.log(jobs);

	return (
		<div className="jobs-list">
			{jobs.length > 0 ? (
				jobs.map((job) => {
					const applyButtonUrl = job.showApply
						? `${
								bseitEditorVars.currentLang === "ar" ? "/ar" : "/en"
						  }/job-details/?id=${job.id}`
						: "#";
					const applyButtonActiveClass = job.showApply
						? "cursor-pointer"
						: "cursor-not-allowed";

					return (
						<div
							className="grid p-5 mt-8 rounded-lg border job-card border-semiGray md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7"
							key={job.id}
						>
							<div className="pe-4">
								<p className="text-darkGray"></p>
								<h3 className="pt-2 font-bold text-black lg:pt-3">
									<a
										href={applyButtonUrl}
										className={`${applyButtonActiveClass} hover:underline`}
										aria-label="Button"
										{...(job.showApply ? {} : { disabled: true })}
										onClick={(e) => {
											if (!job.showApply) {
												e.preventDefault();
											}
										}}
									>
										{BSHelper.truncate(job.title, 40)}
									</a>
								</h3>
							</div>
							<div className="flex gap-2 items-center pt-5 pe-2 md:pt-0 lg:block">
								<p className="text-darkGray">
									{__(phrases.salary, Constants.TEXT_DOMAIN)}
								</p>
								<h2 className="text-[14px] font-normal lg:pt-2 text-[#22282B]">
									{job.salary} {job.currency}
								</h2>
							</div>
							<div className="flex gap-2 items-center pt-5 pe-2 md:pt-0 lg:block">
								<p className="text-darkGray">
									{__(phrases.site_location, Constants.TEXT_DOMAIN)}
								</p>
								<h2 className="text-[14px] font-normal lg:pt-2 text-[#22282B]">
									{job.location}
								</h2>
							</div>
							<div className="flex gap-2 items-center pt-5 pe-2 md:pt-0 lg:block">
								<p className="text-darkGray">
									{__(phrases.nationalities, Constants.TEXT_DOMAIN)}
								</p>
								<h2 className="text-[14px] font-normal lg:pt-2 text-[#22282B]">
									{job.nationalities
										.map((nat) => nat.nationalityName)
										.join(", ")}
								</h2>
							</div>
							<div className="flex gap-2 items-center pt-5 pe-2 md:pt-0 lg:block">
								<p className="text-darkGray">
									{__(phrases.experience, Constants.TEXT_DOMAIN)}
								</p>
								<h2 className="text-[14px] font-normal lg:pt-2 text-[#22282B]">
									{job.experienceLevel.name}
								</h2>
							</div>
							<div className="flex gap-2 items-center pt-5 pe-2 md:pt-0 lg:block">
								<p className="text-darkGray">
									{__(phrases.type, Constants.TEXT_DOMAIN)}
								</p>
								<h2 className="flex gap-2 font-bold lg:pt-2 text-[#22282B]">
									<div className="flex gap-2.5 justify-center items-center px-4 py-0.5 rounded-2xl border border-body">
										<p className="text-xs font-normal leading-relaxed text-center text-[#22282B]">
											{job.jobType}
										</p>
									</div>
								</h2>
							</div>
							<div className="flex gap-3 items-center pt-4 text-end lg:pt-0">
								<a
									href={applyButtonUrl}
									className={`${applyButtonActiveClass} ${
										job.showApply
											? "bg-black hover:bg-white hover:text-black hover:border hover:border-black border-black"
											: "bg-[#909DA2] border-[#909DA2]"
									} w-full py-3 text-white transition-all border rounded-full lg:w-auto px-9 text-center`}
									aria-label="Button"
									{...(job.showApply ? {} : { disabled: true })}
									onClick={(e) => {
										if (!job.showApply) {
											e.preventDefault();
										}
									}}
								>
									{__(phrases.apply_now, Constants.TEXT_DOMAIN)}
								</a>
							</div>
						</div>
					);
				})
			) : (
				<p>{__(phrases.no_jobs_found, Constants.TEXT_DOMAIN)}</p>
			)}
		</div>
	);
};

export default JobsList;
